export const INITIATIVES_SEARCH_SETTINGS = {
	MIN_CHAR_FOR_SEARCH: 3,
	SEARCH_DELAY: 1000
};
